import { withInAppFlag } from "./IAP"

/** Build an app-relative destination; fetching the host and opening it belong to the caller. */
export function serverAppURL(host: string, path: string, inApp: boolean): string {
  const base = new URL(host);
  if (!["http:", "https:"].includes(base.protocol) || base.username || base.password) {
    throw new Error("Invalid server host");
  }
  const appPath = `${base.pathname.replace(/\/+$/, "")}/app/`;
  const destination = new URL(path, new URL(appPath, base));
  if (destination.origin !== base.origin || !destination.pathname.startsWith(appPath)) {
    throw new Error("Invalid server app path");
  }
  destination.search = [base.search.slice(1), destination.search.slice(1)].filter(Boolean).join("&");
  destination.hash ||= base.hash;
  return inApp ? withInAppFlag(destination.href) : destination.href;
}
